/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_To_LabelInputs */

const en_admin_statistics_to_label = /** @type {(inputs: Admin_Statistics_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const de_admin_statistics_to_label = /** @type {(inputs: Admin_Statistics_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Admin_Statistics_To_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_to_label = /** @type {((inputs?: Admin_Statistics_To_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_To_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_to_label(inputs)
	return en_admin_statistics_to_label(inputs)
});